import React from "react";
import { RemoveCircle } from "@mui/icons-material";
import { Alert, AlertTitle } from "@mui/material";

import { Progress } from "ui";

import { useCustomWorkflow } from "fond/hooks/useCustomWorkflow";
import { useAppSelector } from "fond/utils/hooks";
import { BlockSpinner, StackedNavigationButton, useStackedNavigationContext } from "fond/widgets";

const stageConfig: Record<string, { label: string }> = {
  prepare: { label: "Preparing inputs" },
  bom: { label: "Counting materials and costs" },
  c2s: { label: "Calculating cost to serve" },
};

interface DataModificationPanelProps {
  // Flag indicating if the editing is read only
  isReadOnly?: boolean;
}

const DataModificationPanel: React.FC<DataModificationPanelProps> = ({ isReadOnly }) => {
  const { open } = useStackedNavigationContext();
  const versionId = useAppSelector((state) => state.project.versionId);
  const { workflowState, stages, isLoading, runWorkflow } = useCustomWorkflow({ versionId, key: "nbn_cost_to_serve_iteration" });
  const isGeneratingCTS = workflowState === "STARTING" || workflowState === "IN_PROGRESS";

  if (isLoading) return <BlockSpinner />;

  return (
    <>
      {workflowState === undefined && (
        <StackedNavigationButton
          data-testid="data-modiciation-navigation"
          icon={<RemoveCircle />}
          title="Exclude service locations"
          onClick={() => {
            open("excludeDraw");
          }}
          sx={{ m: 0, mt: 1 }}
          disabled={isReadOnly}
        />
      )}

      {workflowState === "COMPLETE" && (
        <Alert severity="success" variant="compact" sx={{ mb: 1 }}>
          Cost to serve generated.
        </Alert>
      )}

      {workflowState === "ERROR" && (
        <Alert severity="error" variant="compact" sx={{ mb: 1 }}>
          <AlertTitle>Cost to serve generation failed</AlertTitle>
          Cost to serve could not be generated.
        </Alert>
      )}

      {stages && (isGeneratingCTS || workflowState === "ERROR") && (
        <Progress steps={stages.map(({ key, status }) => ({ ID: key, Label: stageConfig[key].label, Status: status }))} />
      )}
    </>
  );
};

export default DataModificationPanel;
